import { OpenNewTabTargetType } from "@voltmoney/types";
import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, InputStateToken } from "@voltmoney/schema";
import { api, partnerApi } from "../../../configs/api";
import { getAuthHeaders, getPartnerAuthHeaders } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { getParameters, getPrivacyLinks, getTermsLinks } from "../../../configs/utils";
import { PLATFORM_CODE } from "../../../configs/constants";
let phoneNumber = "";
let isWhatsAppEnabled = true;
let resendAttempts = 1;
/* check userType and call required function */
/* check userType and call required function */
export const sendOtpWithUserTypeCheck = async (action, _datastore, { ...props }) => {
    const userType = await SharedPropsService.getUserType();
    switch (userType) {
        case "PARTNER":
            await sendPartnerOtp(action, {}, props);
            break;
        case "BORROWER":
            await sendOtp(action, {}, props);
            break;
    }
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, action.payload.targetWidgetId, {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const sendOtp = async (action, _datastore, { navigate, setDatastore, instrumentTrack, network }) => {
    phoneNumber = phoneNumber.includes("+91") ? phoneNumber : `+91${phoneNumber}`;
    const isResend = action.payload.isResend;
    instrumentTrack("OTP_SENT");
    if (action.payload.isResend) {
        instrumentTrack("RESEND_OTP_BUTTON_CLICKED", { "attempt_count": resendAttempts });
    }
    if (phoneNumber.length === 13) {
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: true,
        });
        const urlParams = Platform.OS !== "web" ? `${await AsyncStorage.getItem("mobileParams")}` : `${await SharedPropsService.getUrlParams()}`.split("?");
        const urlParamsToBackend = Platform.OS !== "web" ? urlParams : urlParams[1];
        const requestUrl = `${api.loginV2}${phoneNumber}`;
        const response = await network.get(`${requestUrl}?enableWhatsapp=${isWhatsAppEnabled}${urlParams.length > 1 ? `&${urlParamsToBackend}` : ""}`, {
            headers: await getAuthHeaders(),
        });
        if (isResend === true) {
            await setDatastore(action.routeId, "input", {
                state: InputStateToken.DEFAULT,
            });
        }
        if (response.status === 200) {
            const noOfOtpDigits = response?.data?.noOfDigits;
            await setDatastore(action.routeId, action.payload.widgetId, {
                loading: false,
            });
            if (action.payload.isResend == false) {
                await navigate(ROUTE.OTP_VERIFY, {
                    phone_number: phoneNumber,
                    noOfOtpDigits: noOfOtpDigits
                });
            }
            if (action.payload.isResend == false) {
                await setDatastore(action.routeId, "input", {
                    state: InputStateToken.SUCCESS,
                });
            }
        }
        else {
            if (response?.response?.data?.voltErrorCode?.includes("ACCOUNT_BLOCKED_FROM_OTP")) {
                await setDatastore(action.routeId, "input", {
                    state: InputStateToken.ERROR,
                    caption: { error: "OTP limit exceeded. Please retry in 5 minutes." }
                });
                await setDatastore(action.routeId, action.payload.widgetId, {
                    loading: false,
                });
                await setDatastore(action.routeId, "continue", {
                    type: ButtonTypeTokens.LargeOutline
                });
            }
            else {
                await setDatastore(action.routeId, "input", {
                    state: InputStateToken.ERROR,
                });
                instrumentTrack("INVALID_OTP_ENTERED");
                await setDatastore(action.routeId, action.payload.widgetId, {
                    loading: false,
                });
            }
        }
    }
    else {
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: false,
        });
        await setDatastore(action.routeId, "input", {
            state: InputStateToken.ERROR,
        });
    }
};
export const Proceed = async (action, _datastore, { navigate, setDatastore, instrumentTrack, network }) => {
    phoneNumber = `+91${(action?.payload?.value)}`;
    instrumentTrack("OTP_SENT");
    if (phoneNumber.length === 13) {
        const urlParams = Platform.OS !== "web" ? `${await AsyncStorage.getItem("mobileParams")}` : `${await SharedPropsService.getUrlParams()}`.split("?");
        const urlParamsToBackend = Platform.OS !== "web" ? urlParams : urlParams[1];
        const requestUrl = `${api.loginV2}${phoneNumber}`;
        const response = await network.get(`${requestUrl}?enableWhatsapp=${isWhatsAppEnabled}${urlParams.length > 1 ? `&${urlParamsToBackend}` : ""}`, {
            headers: await getAuthHeaders(),
        });
        if (response.status === 200) {
            const noOfOtpDigits = response?.data?.noOfDigits;
            await navigate(ROUTE.OTP_VERIFY, {
                phone_number: phoneNumber,
                noOfOtpDigits: noOfOtpDigits
            });
            await setDatastore(action.routeId, "phoneNumberScreen", {
                state: InputStateToken.SUCCESS,
            });
        }
        else {
            if (response?.response?.data?.voltErrorCode?.includes("ACCOUNT_BLOCKED_FROM_OTP")) {
                await setDatastore(action.routeId, "phoneNumberScreen", {
                    state: InputStateToken.ERROR,
                    caption: { error: "OTP limit exceeded. Please retry in 5 minutes." }
                });
            }
            else {
                await setDatastore(action.routeId, "phoneNumberScreen", {
                    state: InputStateToken.ERROR,
                });
            }
        }
    }
    else {
        await setDatastore(action.routeId, "phoneNumberScreen", {
            state: InputStateToken.ERROR,
        });
    }
};
export const sendPartnerOtp = async (action, _datastore, { navigate, setDatastore, network }) => {
    phoneNumber = phoneNumber.includes("+91") ? phoneNumber : `+91${phoneNumber}`;
    if (phoneNumber.length === 13) {
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: true,
        });
        const response = await network.get(`${partnerApi.login}${phoneNumber}`, {
            headers: getPartnerAuthHeaders(),
        });
        if (response.status === 200) {
            await setDatastore(action.routeId, action.payload.widgetId, {
                loading: false,
            });
            await navigate(ROUTE.OTP_VERIFY, {
                phone_number: phoneNumber,
            });
            await setDatastore(action.routeId, "input", {
                state: InputStateToken.SUCCESS,
            });
        }
        else {
            await setDatastore(action.routeId, action.payload.widgetId, {
                loading: false,
            });
            await setDatastore(action.routeId, "input", {
                state: InputStateToken.ERROR,
            });
        }
    }
    else {
        await setDatastore(action.routeId, action.payload.widgetId, {
            loading: false,
        });
        await setDatastore(action.routeId, "input", {
            state: InputStateToken.ERROR,
        });
    }
};
export const textOnChange = async (action, _datastore, { setDatastore }) => {
    phoneNumber = action.payload.value;
    if (phoneNumber.length === 10 && isWhatsAppEnabled) {
        await setDatastore(action.routeId, "phoneNumberScreen", {
            isDisabled: false,
            state: InputStateToken.DEFAULT,
            caption: { error: "" }
        });
    }
    else {
        await setDatastore(action.routeId, "phoneNumberScreen", {
            isDisabled: true,
            state: InputStateToken.ERROR,
            caption: { error: "Enter a 10 digit mobile number" }
        });
    }
    await setDatastore(action.routeId, "phoneNumberScreen", {
        state: InputStateToken.DEFAULT,
        caption: { error: "" }
    });
};
export const whatsappToggle = async (action, _datastore, { setDatastore }) => {
    isWhatsAppEnabled = action.payload.value;
    if (action.payload.value === false) {
        await setDatastore(action.routeId, "continue", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
    else {
        if (phoneNumber.length === 10) {
            await setDatastore(action.routeId, "continue", {
                type: ButtonTypeTokens.LargeFilled
            });
        }
    }
};
export const goToPrivacy = async (action, _datastore, { navigateWithClear, instrumentTrack }) => {
    instrumentTrack("SIGNUP_T&C_BUTTON_CLICKED");
    navigateWithClear(ROUTE.PRIVACY_POLICY);
};
export const goToPrivacyAction = async (action, _datastore, { openNewTab, navigate }) => {
    const privacyLink = getPrivacyLinks();
    if (Platform.OS === 'web') {
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const isCheckLimit = params?.isCheckLimitMFC;
        const platform = params?.platform;
        if (isCheckLimit &&
            platform &&
            platform === PLATFORM_CODE.PHONEPE) {
            window.parent.postMessage({ id: 'clickedPrivacyPolicy', data: true }, '*');
            return;
        }
    }
    if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */) {
        await navigate(ROUTE.PRIVACY_POLICY);
    }
    else {
        openNewTab(privacyLink, OpenNewTabTargetType.blank);
    }
};
export const goToTermAction = async (action, _datastore, { openNewTab, navigate }) => {
    const termsLink = getTermsLinks();
    const privacyLink = getPrivacyLinks();
    if (Platform.OS === 'web') {
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const isCheckLimit = params?.isCheckLimitMFC;
        const platform = params?.platform;
        if (isCheckLimit &&
            platform &&
            platform === PLATFORM_CODE.PHONEPE) {
            window.parent.postMessage({ id: 'clickedTermsAndConditions', data: true }, '*');
            return;
        }
    }
    if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */) {
        await navigate(ROUTE.PRIVACY_POLICY, { isTerms: true });
    }
    else {
        openNewTab(termsLink, OpenNewTabTargetType.blank);
    }
};
export const mobileNumberProceed = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "panInputStack", {
        hide: false
    });
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "CheckLimitMFCInitStack2", {
        hide: false
    });
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "checkLimitPanSpaceStack", {
        hide: false
    });
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "continueButtonStack", {
        hide: false
    });
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "phoneInputStack", {
        hide: true
    });
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "proceedAfterMobileNumberStack", {
        hide: true
    });
    await setDatastore(ROUTE.CHECK_LIMIT_MFC_INIT, "mobileNumberSpaceStack", {
        hide: true
    });
};
